import * as React from 'react';
import {Button} from "antd";
import { StyledModal } from './StyledModal';

type CompanyDataIsNotFilledProps = {
  isOpen: boolean;
  close: () => void;
}

export const CompanyDataIsNotFilled = ({isOpen, close} : CompanyDataIsNotFilledProps) => {

  return(
    <StyledModal title="Заполните данные о компании" open={isOpen}
    footer={[
        <Button onClick={close} style={{marginRight: '6px'}} key="back">
          Отмена
        </Button>,
        <Button type="primary" href="/editProfileCompany" key="submit">
          Заполнить о компании
        </Button>
      ]}
      onCancel={close}>
    <p> Заполните, пожалуйста, сначала данные о компании, чтобы создать вакансию. </p>
    </StyledModal>
  )
}